export default "__VITE_ASSET__lLX$uWNu__"